const config={
  storageURL:'https://storage.1campus.net/file'
}

export default config;
